var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-aside',{attrs:{"width":"100%"}},[_c('el-tree',{attrs:{"data":_vm.tableData,"props":{ label: 'deptName' },"accordion":""},on:{"node-click":_vm.handleNodeClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }